import { ActorForm } from "features/new-actor/components/ActorForm";
import { ActorFormValues, useSubmitActorForm } from "../hooks/optim/useSubmitActorForm";
import { FC, MutableRefObject, useMemo } from "react";
import { ActorType } from "../enums/actorType";
import { ActorLayoutVariant } from "../enums/actorLayoutVariant";
import { naturalPersonFormConfig } from "../form/naturalPersonFormConfig";
import { legalEntityFormConfig } from "../form/optim/legalEntityFormConfig";
import { FormikProps } from "formik";

interface NewActorProps {
  formikRef: MutableRefObject<FormikProps<ActorFormValues> | null>;
  onValidationChange: (isValid: boolean) => void
  postSubmit?:()=>void
}

export const NewActor: FC<NewActorProps> = ({ formikRef, onValidationChange, postSubmit }) => {
  const {
    handleSubmit,
    editConfig
  } = useSubmitActorForm({ postSubmit, formikRef });

  const formConfig = useMemo(() => ({
    [ActorType.Natural]: naturalPersonFormConfig,
    [ActorType.Legal]: legalEntityFormConfig
  }), []);

  return (
    <ActorForm<ActorFormValues>
      layoutVariant={ActorLayoutVariant.UpiActor}
      formConfig={formConfig}
      formikRef={formikRef}
      editConfig={editConfig}
      onValidationChange={onValidationChange}
      onSubmit={handleSubmit}
    />
  );
};
